import { ROLE_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { IRoleManagementRepository } from "../domain/repositories/IRoleManagementRepository";
import { DetailRoleResponseModel } from "./models/DetailRoleResponseModel";
import { RoleActionRequestModel } from "./models/RoleActionRequestModel";
import { RoleRequestModel } from "./models/RoleRequestModel";
import { RoleResponseModel } from "./models/RoleResponseModel";

@injectable()
export class RoleManagementImpl implements IRoleManagementRepository {
  async getList(
    params: RoleRequestModel,
  ): Promise<ListBaseApiResponseModel<RoleResponseModel>> {
    return await client?.get(ROLE_MANAGEMENT.LIST, params);
  }

  async getDetail(
    params: RoleRequestModel,
  ): Promise<BaseApiResponseModel<DetailRoleResponseModel>> {
    return await client?.get(ROLE_MANAGEMENT.DETAIL, params);
  }

  async updateRole(
    body: RoleActionRequestModel,
  ): Promise<BaseApiResponseModel<RoleResponseModel>> {
    return await client?.put(ROLE_MANAGEMENT.UPDATE, body);
  }

  async createRole(
    body: RoleActionRequestModel,
  ): Promise<BaseApiResponseModel<RoleResponseModel>> {
    return await client?.post(ROLE_MANAGEMENT.CREATE, body);
  }

  async deleteRole(
    params: RoleRequestModel,
  ): Promise<BaseApiResponseModel<RoleResponseModel>> {
    return await client?.delete(ROLE_MANAGEMENT.DELETE, params);
  }
}
